import React, { useState } from "react";
import { IoLockClosedOutline, IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";

const LockIcon = IoLockClosedOutline as any;
const EyeIcon = IoEyeOutline as any;
const EyeOffIcon = IoEyeOffOutline as any;

// Password input with a show/hide toggle, styled like the login form.
const PasswordField: React.FC<{
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  autoComplete: "current-password" | "new-password";
  disabled?: boolean;
  autoFocus?: boolean;
}> = ({ id, label, value, onChange, autoComplete, disabled, autoFocus }) => {
  const [show, setShow] = useState(false);
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-ink-soft mb-1.5">
        {label}
      </label>
      <div className="relative">
        <LockIcon className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 h-5 w-5 text-ink-faint" />
        <input
          id={id}
          type={show ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoComplete={autoComplete}
          autoFocus={autoFocus}
          required
          disabled={disabled}
          className="w-full rounded-xl border border-paper-300 bg-surface pl-11 pr-12 py-3 text-ink-soft placeholder:text-ink-faint focus:border-brand-500 focus:outline-none focus:ring-2 focus:ring-brand-500/30 transition duration-200 disabled:opacity-50"
        />
        <button
          type="button"
          onClick={() => setShow((v) => !v)}
          className="absolute right-3 top-1/2 -translate-y-1/2 p-1.5 rounded-full text-ink-faint hover:text-ink-muted hover:bg-paper-200 transition-colors"
          aria-label={show ? "Hide password" : "Show password"}
        >
          {show ? <EyeOffIcon className="h-5 w-5" /> : <EyeIcon className="h-5 w-5" />}
        </button>
      </div>
    </div>
  );
};

export default PasswordField;
